import { styled } from "@mui/material/styles";
import MuiTimelineItem from "@mui/lab/TimelineItem";
import MuiTimelineSeparator from "@mui/lab/TimelineSeparator";
import MuiTimelineConnector from "@mui/lab/TimelineConnector";
import MuiTimelineContent from "@mui/lab/TimelineContent";
import MuiTimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import MuiTimelineDot from "@mui/lab/TimelineDot";

export const TimelineItem = styled(MuiTimelineItem)(({ theme }) => ({
  backgroundColor: "#fff",
}));

export const SpacerTimelineItem = styled(MuiTimelineItem)(({ theme }) => ({
  minHeight: theme.spacing(3),
}));

export const TimelineSeparator = styled(MuiTimelineSeparator)(({ theme }) => ({
  minWidth: "2.5em",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const TimelineConnector = styled(MuiTimelineConnector)(({ theme }) => ({
  width: "5px",
  backgroundColor: theme.palette.grey[600],
}));

export const TimelineTransparentConnector = styled(MuiTimelineConnector)(({ theme }) => ({
  backgroundColor: "transparent",
}));

export const TimelineContent = styled(MuiTimelineContent)(({ theme }) => ({
  margin: "auto 0",
}));

export const TimelineOppositeContent = styled(MuiTimelineOppositeContent)(({ theme }) => ({
  maxWidth: "0px",
}));

export const TimelineDot = styled(MuiTimelineDot)(({ theme }) => ({
  width: "2.5em",
  height: "2.5em",
  margin: "0px",
  borderColor: theme.palette.grey[600],
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const TimelineExpansionDot = styled(MuiTimelineDot)(({ theme }) => ({
  cursor: "pointer",
  marginTop: "0px",
  marginBottom: "0px",
  borderColor: theme.palette.primary.main,
  display: "flex",
  justifyContent: "center",
  alignSelf: "center",
}));

export const TimelineNumberDot = styled(MuiTimelineDot)(({ theme }) => ({
  width: "1.6em",
  height: "1.6em",
  marginTop: "0px",
  marginBottom: "0px",
  borderColor: theme.palette.primary.main,
  backgroundColor: theme.palette.primary.main,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  alignSelf: "center",
}));

export const TimelineEndDot = styled(MuiTimelineDot)(({ theme }) => ({
  borderRadius: "0%",
  width: "1.3em",
  marginTop: "0px",
  marginBottom: "0px",
  borderWidth: "0px",
  backgroundColor: theme.palette.grey[600],
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  alignSelf: "center",
  boxShadow: "none",
}));
